import { render } from "./Masthead.vue?vue&type=template&id=04b884b6&ts=true"
import script from "./Masthead.vue?vue&type=script&lang=ts"
export * from "./Masthead.vue?vue&type=script&lang=ts"

import "./Masthead.vue?vue&type=style&index=0&id=04b884b6&lang=css"

import exportComponent from "/home/vendor/oesb/ispk-client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__